<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Precios</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center">
    <button class="btn btn-secondary header-add-btn" type="button" (click)="abrirModalAgregar(mdlAgregarValor)">
      Agregar
    </button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">
      <div class="card-body">
        @if (cargando) {
          <div class="text-center">
            <div class="spinner-grow" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br>
              <p class="text-center">Consultando por favor espere...</p>
            </div>
          }

          @if (!cargando && precios.length === 0) {
            <div class="empty-state">
              <div class="empty-state__icon">
                <i class="fa fa-dollar"></i>
              </div>
              <h5>No hay precios registrados</h5>
              <p>Agrega un valor y relaciónalo con un tipo de precio.</p>
            </div>
          }

          @if (!cargando && precios.length > 0) {
            <div class="table-responsive d-none d-md-block">
              <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Valor</th>
                    <th>Tipo</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (precio of precios; track precio; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ precio.VAL_PREC | currency:'USD':'symbol':'1.2-2' }}</td>
                      <td class="text-uppercase">{{ precio.DES_TIPPREC }}</td>
                      <td>
                        <div class="action-group">
                          <button class="btn btn-warning btn-sm" type="button" (click)="abrirModalEditar(mdlEditarValor, precio)">
                            <i class="zmdi zmdi-edit text-white"></i>
                          </button>
                          <button class="btn btn-danger btn-sm" type="button" (click)="eliminarPrecio(precio)">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          @if (!cargando && precios.length > 0) {
            <div class="mobile-list d-md-none">
              @for (precio of precios; track precio; let i = $index) {
                <article class="mobile-card">
                  <div class="mobile-card__head">
                    <span class="mobile-index">#{{ i + 1 }}</span>
                    <span class="mobile-value">{{ precio.VAL_PREC | currency:'USD':'symbol':'1.2-2' }}</span>
                  </div>
                  <div class="mobile-card__type">
                    {{ precio.DES_TIPPREC }}
                  </div>
                  <div class="mobile-card__actions">
                    <button class="btn btn-warning btn-sm" type="button" (click)="abrirModalEditar(mdlEditarValor, precio)">
                      Editar
                    </button>
                    <button class="btn btn-danger btn-sm" type="button" (click)="eliminarPrecio(precio)">
                      Eliminar
                    </button>
                  </div>
                </article>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template #mdlAgregarValor let-modal>
    <div class="modal-header">
      <h6 class="modal-title">Agregar valor</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group mb-3">
        <label class="form-label">Valor</label>
        <input
          type="number"
          min="0"
          step="0.01"
          class="form-control"
          [(ngModel)]="nuevoValor"
          placeholder="Ingresar..."
          [disabled]="guardando">
      </div>

      <div class="form-group mb-0">
        <label class="form-label">Tipo de precio</label>
        <select class="form-control" [(ngModel)]="nuevoTipoPrecio" [disabled]="guardando">
          <option value="">Seleccione tipo precio....</option>
          @for (tipo of tipoPrecios; track tipo) {
            <option [value]="tipo.COD_TIPPREC">
              {{ tipo.DES_TIPPREC }}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')" [disabled]="guardando">Salir</button>
      <button type="button" class="btn btn-secondary" (click)="crearPrecio()" [disabled]="guardando">
        {{ guardando ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>
  </ng-template>

  <ng-template #mdlEditarValor let-modal>
    <div class="modal-header">
      <h6 class="modal-title">Editar valor</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group mb-3">
        <label class="form-label">Valor</label>
        <input
          type="number"
          min="0"
          step="0.01"
          class="form-control"
          [(ngModel)]="editarValor"
          placeholder="Ingresar..."
          [disabled]="guardando">
      </div>

      <div class="form-group mb-0">
        <label class="form-label">Tipo de precio</label>
        <select class="form-control" [(ngModel)]="editarTipoPrecio" [disabled]="guardando">
          <option value="">Seleccione tipo precio....</option>
          @for (tipo of tipoPrecios; track tipo) {
            <option [value]="tipo.COD_TIPPREC">
              {{ tipo.DES_TIPPREC }}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel')" [disabled]="guardando">Salir</button>
      <button type="button" class="btn btn-secondary" (click)="actualizarPrecio()" [disabled]="guardando">
        {{ guardando ? 'Guardando...' : 'Guardar cambios' }}
      </button>
    </div>
  </ng-template>
